export async function fetchTariffs(actionCode: string, locale: string) {
  const runtimeConfig = useRuntimeConfig()
  const client = runtimeConfig.public.client

  return await $fetch
    .raw('/tariffs', {
      baseURL: runtimeConfig.public.apiBaseURL,
      method: 'GET',
      query: {
        client: client,
        language: locale,
        actioncode: actionCode,
      },
    })
    .catch((error) => {
      return error.data
    })
}
